// extracted by css-extract-rspack-plugin
export default {"root":"src-components-NodeStatus-NodeStatus-module__root-QfM_bG","loadingContent":"src-components-NodeStatus-NodeStatus-module__loadingContent-IScGqJ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-NodeStatus-NodeStatus-module__root-QfM_bG\",\"loadingContent\":\"src-components-NodeStatus-NodeStatus-module__loadingContent-IScGqJ\"}";
        // 1790730173120
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  